// Chips de estado de las pantallas de detalle. Una rectificativa por anulación (la negativa) se muestra siempre como
// "Anulación" en gris: nunca como "Emitida" ni como cobrada/pendiente. Una anulada sin cobrar tampoco se muestra como
// "Pendiente" (en rojo): no hay nada que cobrar.
type ColorChip = "success" | "default" | "error";

interface FacturaParaChips {
  estado?: string;
  estadoPago?: string;
  tipoRectificacion?: string | null;
}

export const chipEstadoFactura = (f?: FacturaParaChips | null): { label: string; color: ColorChip } => {
  if (f?.tipoRectificacion === "anulacion") return { label: "Anulación", color: "default" };
  return { label: f?.estado ?? "", color: f?.estado === "Emitida" ? "success" : "default" };
};

export const chipEstadoPago = (f?: FacturaParaChips | null): { label: string; color: ColorChip } => {
  if (f?.tipoRectificacion === "anulacion") return { label: "Anulación", color: "default" };
  if (f?.estado === "Anulada" && f?.estadoPago !== "Pagada") return { label: "Anulada", color: "default" };
  return { label: f?.estadoPago ?? "", color: f?.estadoPago === "Pagada" ? "success" : "error" };
};
